import { combineStyles, media, mixins } from '@blend/consumer-components';
import { StyleSheet } from 'aphrodite';

const activationStyles = StyleSheet.create({
  activation: combineStyles(mixins.margin(0, 'auto'), {
    maxWidth: 725,

    [media.smallViewMaxWidth]: {
      // We set an explicit width and unset max-width here because
      // the mobile signup element isn't designed to be variable-width.
      width: 290,
      maxWidth: 'none',
    },
  }),
});

export default activationStyles;
